import React, { useMemo, useRef, useState } from "react"

import modStyl from './index.module.scss'

import Condition from "./components/condition"
import { Button, Empty, Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import DetailModal, { fetcChallList, makeLast, Options, Payload } from "./components/detail-modal"
import { useFetchStatus } from "./repo"
import { readTargetName } from "../../../../utils/storage"

type CellsProps = {
  label: string
  value: [string, string, string]
}
const Cells: React.FC<CellsProps> = ({ label, value })=> {
  if (value ) {
    const [createUser, role, createTime] = value
    return (
      <dl className={modStyl.blk}>
      <dd>{label}者: {createUser}</dd>
      <dd>角色: {role}</dd>
      <dd>{label}时间: {createTime}</dd>
    </dl>
    )
  }
  return <span>-</span>
}

export type DataResult = {
  code: number;
  message?: string;
  data: {
    page: number;
    pageSize: number;
    total: number;
    rows: DataType[];
  }
}

export type DataType = {
  id: string
  qid: string
  label: string
  projectName: string
  content: string
  subjectCode: string
  dataCode: string
  deCode: string
  enter: string
  formId: null
  formName: string
  questionCreateUser: string
  questionRole: string
  questionCreateTime: string
  questionId: string
  questionText: string
  questionStatus: string
  replierCreateUser: string
  replierRole: string
  replierCreateTime: string
  closeCreateUser: string
  closeRrole: string
  closeCreateTime: string
  visitName: string
  isLock: null
}

const Chall = ()=> {

  const { statusMap } = useFetchStatus()

  const [visible, setVisible] = useState(false)
  
  const [pageSize] = useState(20)
  const [pageNum, setPageNum] = useState(1)
  
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [dataSource, setDataSource] = useState<DataType[]>([])

  const targetName = useMemo(()=> readTargetName(), [])

  const conditionRef = useRef<Payload>({})

  const [options, setOptions] = useState({} as Options)

  // 计算详情需要的翻面参数
  const makeOptions = (index: number)=> {
    const last = makeLast(index, total, pageNum, pageSize)
    return {
      index,
      last,
      condition: conditionRef.current,
      pageNum,
      pageSize,
      total,
      records: dataSource
    }
  }

  //#region 表格列
  const columns: ColumnsType<DataType> = [
    {
      width: 140,
      title: '项目名称',
      ellipsis: true,
      dataIndex: 'projectName',
    },
    {
      width: 120,
      align: 'center',
      title: '所属中心',
      dataIndex: 'centerName',
    },
    {
      width: 120,
      align: 'center',
      title: '采集人',
      dataIndex: 'createUser',
    },
    {
      width: 120,
      align: 'center',
      title: `${targetName}编号`,
      dataIndex: 'subjectCode',
    },
    {
      width: 130,
      align: 'center',
      title: '所在访视',
      dataIndex: 'visitName',
    },
    {
      width: 120,
      align: 'center',
      title: '表单名称',
      dataIndex: 'formName',
    },
    {
      width: 120,
      align: 'center',
      title: '页面编号',
      dataIndex: 'qid',
      render: (value)=> value || '-'
    },
    {
      width: 130,
      align: 'center',
      title: '表单是否补充录入',
      dataIndex: 'enter',
      render: (value: number)=> ['未完成', '已完成', '无需补充录入'][value] || '-',
    },
    {
      width: 100,
      title: '表单是否锁定',
      align: 'center',
      dataIndex: 'isLock',
      render: (value: number)=> value === 1 ? '是' : '否'
    },
    {
      width: 160,
      title: '质疑类型',
      dataIndex: 'questionType',
      render: (value)=> value || '-'
    },
    {
      width: 160,
      title: '质疑字段',
      dataIndex: 'label',
      render: (value)=> value || '-'
    },
    {
      width: 160,
      title: '质疑文本',
      dataIndex: 'questionText',
      render: (value)=> value || '-'
    },
    {
      width: 100,
      title: '质疑发起者',
      dataIndex: 'questionCreateUser',
      render: (value: string)=> value || '-'
    },
    {
      width: 120,
      title: '质疑发起者角色',
      dataIndex: 'questionRole',
      render: (value: string)=> value || '-'
    },
    {
      width: 160,
      title: '质疑发起时间',
      dataIndex: 'questionCreateTime',
      render: (value: string)=> value || '-'
    },
    {
      width: 100,
      title: '质疑回复者',
      dataIndex: 'replierCreateUser',
      render: (value: string)=> value || '-'
    },
    {
      width: 120,
      title: '质疑回复者角色',
      dataIndex: 'replierRole',
      render: (value: string)=> value || '-'
    },
    {
      width: 160,
      title: '质疑回复内容',
      dataIndex: 'content',
      render: (value)=> value || '-'
    },
    {
      width: 160,
      title: '质疑回复时间',
      dataIndex: 'replierCreateTime',
      render: (value: string)=> value || '-'
    },
    {
      width: 100,
      title: '质疑关闭者',
      dataIndex: 'closeCreateUser',
      render: (value: string)=> value || '-'
    },
    {
      width: 120,
      title: '质疑关闭者角色',
      dataIndex: 'closeRrole',
      render: (value: string)=> value || '-'
    },
    {
      width: 160,
      title: '质疑关闭时间',
      dataIndex: 'closeCreateTime',
      render: (value: string)=> value || '-'
    },
    {
      fixed: 'right',
      width: 100,
      title: '状态',
      dataIndex: 'questionStatus',
      render: (value: string)=> statusMap.get(value) || '-'
    },
    {
      fixed: 'right',
      width: 100,
      title: '操作',
      key: 'action',
      render: (_: any, record: DataType, index: number) => (
        <Button onClick={ ()=> {
          setVisible(true)
          setOptions(makeOptions(index))
        }} type="primary" size="small">查看详情</Button>
      ),
    },
  ];
  //#endregion

  const fetchData = async (params: Payload, page = 1)=> {
    setLoading(true)
    const [a, b] = await fetcChallList(page, pageSize, params)
    setLoading(false)
    setPageNum(page)
    setTotal(a)
    setDataSource(b)
  }

  const onSearch = (params?: Payload)=> {
    if (typeof params === 'undefined') {
      conditionRef.current = {}
    } else {
      conditionRef.current = params
    }
    fetchData(params || {})
  }

  // 当图片审核状态变更后及时刷新列表数据
  const refreshControl = (needReload=false)=> {
    setVisible(false)
    if(needReload) {
      fetchData(conditionRef.current)
    }
  }

  return (
    <>
    <div className={modStyl.wrapper}>
      <Condition onSearch={onSearch}/>
      <div className={modStyl.tableWrapper}>
        <Table
          loading={loading}
          size="middle"
          rowKey="id"
          scroll={{y: window.innerHeight - 350}}
          columns={columns}
          dataSource={dataSource}
          locale={{emptyText: <Empty description="暂无数据"/>}}
          pagination={{
            onChange: (page: number)=> fetchData(conditionRef.current, page),
            total: total,
            current: pageNum,
            pageSize: pageSize,
            hideOnSinglePage: true,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: total=> `共${total}条，每页${pageSize}条`,
            position: ["bottomRight"]}}/>
      </div>
    </div>
    {
      visible && (
        <DetailModal onClose={refreshControl} options={options}/>
      )
    }
    </>
  )
}

export default Chall